// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"14754731","183":"b3cd329e","479":"48feecb7","734":"0f66a28d","799":"f62e004a","873":"a3de4730","944":"71e7e9de"}[chunkId] + ".chunk.js";
};